export default __webpack_public_path__ + "static/tooltip-critical-dont-light-7bcdc01c27cd67a2bcd68c4e72117974.png";